'use strict'

const mapValues_ = require('lodash/mapValues')
const get_ = require('lodash/get')
const recordActions = require('../records/actions')
const actionTypes = require('./actionTypes')
const componentRoles = require('../componentRoles')
const queue = require('../actions-queue/addToQueue')
const { areDependenciesResolved } = require('../dataset-controller/rootReducer')

const createDependencyEntries = ({ controllerApi, connectionConfig }) =>
  mapValues_(connectionConfig.filters, ({ fieldName }) => ({
    fieldName,
    controllerApi
  }))

const refreshDatasetOnControllerEvent = (controller, event, dispatch) => {
  try {
    return controller[event](() => dispatch(recordActions.refresh()))
  } catch (ex) {
    // registering to onItemValuesChanged when the dataset is in read only mode will throw error
    // ignore dataset errors and return empty unsubscribe handle
    if (get_(ex, 'code') === 'OPERATION_NOT_ALLOWED') {
      return () => {}
    }
    throw ex
  }
}

const resolveDependencies = dependenciesIds => ({
  type: actionTypes.RESOLVE_DEPENDENCIES,
  dependenciesIds
})

const performHandshakes = dependenciesIds => ({
  type: actionTypes.PERFORM_HANDSHAKES,
  dependenciesIds
})

module.exports.resolveMissingDependencies = () => ({
  type: actionTypes.RESOLVE_MISSING_DEPENDENCIES
})

module.exports.setDependencies = dependenciesIds => ({
  type: actionTypes.SET_DEPENDENCIES,
  dependenciesIds
})

module.exports.performHandshake = ({
  controllerApi,
  connectionConfig,
  role
}) => (dispatch, getState, { dependenciesManager }) => {
  if (role === componentRoles.DETAILS_DATASET) {
    const entries = createDependencyEntries({ controllerApi, connectionConfig })
    const dependenciesIds = Object.keys(entries)

    dependenciesManager.add(entries)
    dispatch(performHandshakes(dependenciesIds))

    const onReadyHandle = controllerApi.onReady(() => {
      dispatch(resolveDependencies(dependenciesIds))

      const indexHandle = refreshDatasetOnControllerEvent(
        controllerApi,
        'onCurrentIndexChanged',
        dispatch
      )
      const valuesHandle = refreshDatasetOnControllerEvent(
        controllerApi,
        'onItemValuesChanged',
        dispatch
      )

      dependenciesManager.saveHandle(indexHandle)
      dependenciesManager.saveHandle(valuesHandle)
    })
    dependenciesManager.saveHandle(onReadyHandle)
  }
}

module.exports.waitForDependencies = store =>
  queue(
    () =>
      new Promise(resolve => {
        if (areDependenciesResolved(store.getState())) {
          resolve()
        } else {
          const unsubscribe = store.subscribe(() => {
            if (areDependenciesResolved(store.getState())) {
              unsubscribe()
              resolve()
            }
          })
        }
      })
  )



// WEBPACK FOOTER //
// ./dependency-resolution/actions.js